
/**
  Used for product card and qds-tag in order to trim text that is passed as parameter to component with shadowRoot.
  It is very speciific case, in order to use it in another palces,
  please make cardsHorizontalSizingForScreenWidthRange as parameter to function,and adjust values to requirements.
*/
export const truncateTextForScreenWidth = (text: string, size?: string) => {
    const windowWidth = window.innerWidth;
    const characterWidth = 8; // Assuming average character width is 8px
    const maxCharactersPerLine = (availableWidth: number) => Math.floor(availableWidth / characterWidth);

    const getCardsHorizontalSizingForScreenWidthRange = () => {
        switch (size) {
        case 'xsmall':
          return {
            1175: 180,
            1020: 320,
            829: 180,
            370: 320,
            0: 340
          };
        case 'small':
          return {
            1175: 200,
            370: 190,
            0: 240
          };
        case 'medium':
          return {
            1175: 235,
            1060: 340,
            930: 300,
            840: 190,
            370: 10000,
            0: 240
          };
        case 'large':
          return {
            370: 10000,
            0: 240
          };
        default:
          return {
            370: 10000,
            0: 240
          };
        }
    };

    const cardsSizing = getCardsHorizontalSizingForScreenWidthRange();

    const availableWidth =
    Object.entries(cardsSizing)
      .reverse()
      .find(([key]) => windowWidth > Number(key))?.[1] || cardsSizing[0];

    const maxChars = maxCharactersPerLine(+availableWidth);

    return text.length > maxChars ? text.substring(0, maxChars).trim() + '...' : text;
};
